import { Link } from "react-router-dom";
import ProductCard from "@/components/ProductCard";
import { useWishlist } from "@/context/WishlistContext";
import { useAuth } from "@/context/AuthContext";

export default function Wishlist() {
  const { items } = useWishlist();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="px-6 md:px-24 py-24 text-center">
        <div className="font-serif-h text-3xl">Sign in to view your wishlist</div>
        <Link to="/login" className="btn-ink mt-6 inline-flex">Sign In</Link>
      </div>
    );
  }

  return (
    <div className="px-6 md:px-12 lg:px-24 py-16 min-h-[70vh]" data-testid="wishlist-page">
      <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Saved</div>
      <h1 className="font-serif-h font-light text-5xl text-stone-900">Wishlist</h1>
      <div className="text-sm text-stone-500 mt-2">{items.length} pieces saved</div>

      {items.length === 0 ? (
        <div className="mt-16 text-center py-16 border border-warm">
          <div className="font-serif-h text-2xl text-stone-800">Your wishlist is empty</div>
          <p className="text-stone-500 mt-2 text-sm">Save the pieces you love for later.</p>
          <Link to="/shop/sarees" className="btn-ink mt-6 inline-flex">Explore Collection</Link>
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
